export default "__VITE_ASSET__CEeP_Fsw__"